import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPage, goBack } from "../../store/slices/pageSlice";
import Header from "../../components/header/Header";
import DetailInfoTable from "../../components/PromoDetail/DetailInfoTable";
import Tasks from "../../components/PromoDetail/Tasks";

export default function PromoDetails() {
    const dispatch = useDispatch();
    const selectedPromo = useSelector((state) => state.selectedPromo.promo);
    const currentPageId = useSelector((state) => state.page.currentPageId);

    // Лог при монтировании компонента
    useEffect(() => {
        console.log('🔵 PromoDetails: Компонент смонтирован');
        console.log('📋 PromoDetails: Данные промо из Redux:', selectedPromo);
    }, []);

    // Лог когда переходим на эту страницу (pageId === 5)
    useEffect(() => {
        if (currentPageId === 5) {
            console.log('🟢 PromoDetails: Переход на страницу PromoDetails');
            console.log('📋 PromoDetails: Данные промо:', selectedPromo);
        }
    }, [currentPageId, selectedPromo]);

    // Лог при изменении selectedPromo
    useEffect(() => {
        console.log('📋 PromoDetails: selectedPromo изменился:', selectedPromo);
    }, [selectedPromo]);

    const handleClose = () => {
        dispatch(goBack());
    };


    return (
        <div className="w-full h-full flex flex-col overflow-hidden">
            <div className="pt-[24px] pb-[10px] flex-shrink-0">
                <Header
                    leftButtonText="Close"
                    centerTitle="OxyCrystals"
                    onLeftClick={handleClose}
                    useBackIcon={false}
                />
            </div>
            <div className="flex-1 overflow-y-auto px-[9px] flex flex-col gap-4 pb-5">
                <DetailInfoTable data={selectedPromo} />
                <Tasks/>
            </div>
        </div>
    );
}
